/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "azure-devops-ui/Ago", "azure-devops-ui/Card", "azure-devops-ui/Core/Util/String", "azure-devops-ui/Header", "azure-devops-ui/Link", "azure-devops-ui/TooltipEx", "azure-devops-ui/Util", "react", "../../Resources", "../Common/KubeCardWithTable", "../Common/Tags", "../Constants", "../FluxCommon/StoreManager", "../ImageDetails/ImageDetailsStore", "../RunDetails", "../Utils", "./PodOverview.scss"], function (require, exports, Ago_1, Card_1, String_1, Header_1, Link_1, TooltipEx_1, Util_1, React, Resources, KubeCardWithTable_1, Tags_1, Constants_1, StoreManager_1, ImageDetailsStore_1, RunDetails_1, Utils_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PodOverview = /** @class */ (function (_super) {
        __extends(PodOverview, _super);
        function PodOverview() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this._getCardContent = function () {
                var items = PodOverview._getPodDetails(_this.props.pod, _this.props.showImageDetails);
                var rowClassNames = "flex-row details-card-row-size";
                var keyClassNames = "text-ellipsis secondary-text details-card-info-field-size";
                return (React.createElement("div", { className: "flex-column details-card-content body-m" }, items.map(function (item, index) {
                    return (item.key === Resources.ImageText)
                        ? (React.createElement("div", { className: index === 0 ? Util_1.css("pod-image-data", rowClassNames, "first-row") : Util_1.css("pod-image-data", rowClassNames), key: index },
                            React.createElement("div", { className: Util_1.css("pod-image-key", keyClassNames) }, item.key),
                            PodOverview._renderImageCell(item)))
                        : (React.createElement("div", { className: index === 0 ? Util_1.css(rowClassNames, "first-row") : rowClassNames, key: index },
                            React.createElement("div", { className: keyClassNames }, item.key),
                            PodOverview._renderValueCell(item)));
                })));
            };
            return _this;
        }
        PodOverview.prototype.render = function () {
            return (React.createElement(Card_1.CustomCard, { className: "pod-overview-card k8s-card-padding flex-grow bolt-card-no-vertical-padding" },
                React.createElement(Header_1.CustomHeader, null,
                    React.createElement(Header_1.HeaderTitleArea, null,
                        React.createElement(Header_1.HeaderTitleRow, null,
                            React.createElement(Header_1.HeaderTitle, { className: "text-ellipsis", titleSize: 0 /* Medium */ }, Resources.PodDetailsHeader)))),
                React.createElement(Card_1.CardContent, { className: "pod-full-details-table", contentPadding: true }, this._getCardContent())));
        };
        PodOverview.prototype.componentDidMount = function () {
            this._markTTI();
        };
        PodOverview.prototype._markTTI = function () {
            if (this.props.markTTICallback) {
                this.props.markTTICallback({
                    "scenario": Constants_1.Scenarios.PodOverview
                });
            }
        };
        PodOverview._getPodConditionsText = function (pod) {
            var conditions = [];
            if (pod.status) {
                conditions = (pod.status.conditions || []).map(function (condition) { return String_1.localeFormat("{0}={1}", condition.type || "", condition.status || ""); });
            }
            return conditions.join("; ") || "";
        };
        PodOverview._getPodDetails = function (pod, showImageDetails) {
            var createTime = pod.metadata.creationTimestamp ? new Date(pod.metadata.creationTimestamp) : new Date().getTime();
            var statusReason = pod.status.reason ? String_1.localeFormat(" | {0}", pod.status.reason) : "";
            var statusText = String_1.localeFormat("{0}{1}", pod.status.phase, statusReason);
            var hasAnnotations = pod.metadata.annotations && Object.keys(pod.metadata.annotations).length > 0;
            var hasLabels = pod.metadata.labels && Object.keys(pod.metadata.labels).length > 0;
            var _a = Utils_1.Utils.getImageText(pod.spec), imageText = _a.imageText, imageTooltipText = _a.imageTooltipText;
            var imageId = Utils_1.Utils.getImageIdsForPods([pod])[0] || "";
            var conditionsText = PodOverview._getPodConditionsText(pod);
            var jobName = RunDetails_1.getRunDetailsText(pod.metadata.annotations);
            var podDetails = [];
            // order of rows to be preserved as per spec
            createTime && podDetails.push({ key: Resources.Created, value: createTime });
            jobName && podDetails.push({ key: Resources.JobText, value: jobName });
            hasAnnotations && podDetails.push({ key: Resources.AnnotationsText, value: pod.metadata.annotations });
            pod.spec.restartPolicy && podDetails.push({ key: Resources.RestartPolicyText, value: pod.spec.restartPolicy });
            pod.status.qosClass && podDetails.push({ key: Resources.QoSClassText, value: pod.status.qosClass });
            pod.spec.nodeName && podDetails.push({ key: Resources.NodeText, value: pod.spec.nodeName });
            imageText && podDetails.push({ key: Resources.ImageText, value: imageText, valueTooltipText: imageTooltipText, imageId: imageId, showImageDetails: showImageDetails });
            hasLabels && podDetails.push({ key: Resources.LabelsText, value: pod.metadata.labels });
            statusText && podDetails.push({ key: Resources.StatusText, value: statusText });
            conditionsText && podDetails.push({ key: Resources.ConditionsText, value: conditionsText });
            return podDetails;
        };
        PodOverview._renderValueCell = function (tableItem) {
            var key = tableItem.key, value = tableItem.value, valueTooltipText = tableItem.valueTooltipText;
            switch (key) {
                case Resources.Created:
                    return (React.createElement("div", { className: "text-ellipsis details-card-value-field-size" },
                        React.createElement(Ago_1.Ago, { date: new Date(value), format: 1 /* Extended */ })));
                case Resources.LabelsText:
                case Resources.AnnotationsText:
                    return (React.createElement("div", { className: "text-ellipsis details-card-value-field-size" },
                        React.createElement(Tags_1.Tags, { items: value, className: "body-s" })));
                default:
                    return KubeCardWithTable_1.defaultColumnRenderer(value, "details-card-value-field-size", valueTooltipText);
            }
        };
        PodOverview._renderImageCell = function (tableItem) {
            var key = tableItem.key, value = tableItem.value, valueTooltipText = tableItem.valueTooltipText, imageId = tableItem.imageId, showImageDetails = tableItem.showImageDetails;
            var imageDetailsStore = StoreManager_1.StoreManager.GetStore(ImageDetailsStore_1.ImageDetailsStore);
            var imageDetailsUnavailableTooltipText = "";
            var hasImageDetails = imageDetailsStore.hasImageDetails(imageId);
            // if hasImageDetails is undefined, then image details promise has not resolved, so do not set imageDetailsUnavailable tooltip
            if (hasImageDetails === false) {
                imageDetailsUnavailableTooltipText = String_1.localeFormat("{0} | {1}", valueTooltipText || value, Resources.ImageDetailsUnavailableText);
            }
            return hasImageDetails ?
                React.createElement(TooltipEx_1.Tooltip, { overflowOnly: true },
                    React.createElement("div", { className: "pod-image-link details-card-value-field-size" },
                        React.createElement(Link_1.Link, { className: "fontSizeM font-size-m text-ellipsis bolt-table-link", rel: "noopener noreferrer", onClick: function (e) {
                                e.preventDefault();
                                showImageDetails(imageId);
                            } }, value)))
                : KubeCardWithTable_1.defaultColumnRenderer(value, "pod-image-nolink details-card-value-field-size", imageDetailsUnavailableTooltipText);
        };
        return PodOverview;
    }(React.Component));
    exports.PodOverview = PodOverview;
});
